<script>
// import AccountBar from '@/components/account-bar'
import AppBar from "@/components/app-bar";
import AppFooter from "@/components/app-footer";
import * as api from "@/services/api.js";
import { timeout } from "@/services/utils.js";

export default {
  name: "SOLParser",
  components: {
    // AccountBar,
    AppBar,
    AppFooter,
  },
  data: () => ({
    isLoading: true,
    savedAccounts: [],
    scrollPos: 0,
  }),
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
    vuetify() {
      return this.$vuetify;
    },
  },
  methods: {
    onScroll(e) {
      this.scrollPos = e?.target?.scrollingElement?.scrollTop;
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    async syncAccountData() {
      const data = await api.get("account");
      if (data?.status !== "ok") {
        console.error(data);
        this.$store.dispatch("triggerSnackbar", {
          message: "Error getting app account data",
          color: "error",
        });
      }
      if (data?.companyData?.data) {
        this.$store.state.accountCompany = { ...data.companyData.data };
      }
      if (data?.trailerMap?.data) {
        this.$store.dispatch("setTrailerMap", { ...data.trailerMap.data });
      }
      return data;
    },
  },
  async created() {
    //api service will handle redirect to login page if !auth
    // console.log('TODO: if !route = login, set loading while checking auth')
    if (this?.$route?.name === "energy") {
      //no auth required for energy graphic report
      this.isLoading = false;
      return;
    }

    let resp;
    try {
      resp = await api.get("auth");
    } catch (e) {
      console.log("error fetching auth");
    }
    //if status == ok
    if (resp?.status === "ok") {
      //accounts, activeAccount, accountplants..
      this.$store.dispatch("setActiveAccount", resp?.account || {});
      this.$store.dispatch("setActiveAccountTrailers", resp?.trailers || []);
      //for now we are only using a single, sol account as login
      //keep for future expansion of multiple accounts

      this.$store.dispatch("setIsAuth", true);
      await timeout(3000);
      await this.syncAccountData();
      await this.$nextTick();
      this.isLoading = false; //not needed?
      if (this.$route.path === "/login") {
        this.$router.push("/");
      }
    } else {
      this.isLoading = false;
    }
  },
};
</script>

<template>
  <div id="app">
    <v-app>
      <app-bar v-if="$route?.name !== 'energy'"></app-bar>
      <v-main v-scroll="onScroll" class="pb-0">
        <v-container class="main-container d-flex flex-column align-center">
          <!-- TODO: SEPARATE LOGIN FROM MAIN APP -->
          <!-- <account-bar v-if="$store?.state?.isAuth"></account-bar> -->
          <v-progress-linear
            v-if="isLoading"
            color="primary"
            indeterminate
          ></v-progress-linear>

          <router-view v-else :key="$route.fullPath" />
          <v-fab-transition>
            <v-btn
              v-show="scrollPos > 500"
              color="primary"
              dark
              fixed
              bottom
              right
              fab
              @click="scrollTop"
              class="mr-4 mb-4"
            >
              <v-icon large>mdi-chevron-up</v-icon>
            </v-btn>
          </v-fab-transition>
          <v-snackbar
            :value="snackbar.show"
            bottom
            center
            :color="snackbar.color"
            dissmissable
            timeout="3000"
            @input="$store.dispatch('triggerSnackbar')"
            ><v-icon class="mr-4">mdi-information</v-icon>
            <span class="font-weight-bold">{{
              snackbar.message
            }}</span></v-snackbar
          >
        </v-container>
      </v-main>
      <app-footer v-if="$route?.name !== 'energy'"></app-footer>
    </v-app>

    <!-- <nav> -->
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    <!-- </nav> -->
    <!--

    scrollTop() {
      //todo: create content element where this
      //button is attached to. dont prefer using watchers
      this.$store.dispatch('setScrollElementPos', 0)
      return
      if (this.$store.state.scrollElement) {
        this.$store.state.scrollElement.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },

 -->
  </div>
</template>

<style>
:root {
  --primary-color: #51bfa0;
  --secondary-color: #ffffff;
  --accent-color: #8bc53e;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  /* background-color: #f9f5f5; */
}

.full-width {
  width: 100%;
}

.default-dialog {
  position: relative;
}

.default-dialog .close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

.header {
  width: clamp(10rem, 20rem, 100vw);
  min-width: 220px;
  position: relative;
  display: inline-block;
  padding-top: 1rem;
  margin-bottom: 2rem;
}

.logo {
  display: block;
  height: 3rem;
  width: 3rem;
}

.subtext {
  /* font-family: 'Marck Script', cursive; */
  /* font-size: clamp(2rem, 3rem, 100vw); */
  font-size: 1.5rem;
  letter-spacing: 0.025ch;
  font-weight: bold;
  color: #51bfa0;
  /* position: absolute;
    bottom: -30px;
    left: 20px; */
}

.pointer {
  cursor: pointer;
}

.main-container {
  /* max-width: 900px; */
  margin: 0;
  /* padding: 0; */
  min-width: 100%;
}

/* MODALS */
.close-btn {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
